uniform sampler2D u_texture;
uniform sampler2D u_normalMap;
varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vWorldPos;
varying mat3 vTbn;

void main(){
    vec3 sunDir=normalize(-vWorldPos);
    vec3 baseColor=texture2D(u_texture,vUv).rgb;
    
    vec3 tnormRaw=texture2D(u_normalMap,vUv).xyz*2.-1.;
    vec3 N_pert=normalize(vTbn*tnormRaw);
    vec3 N=normalize(mix(vNormal,N_pert,.5));
    
    float diff=max(dot(N,sunDir),0.);
    float ambient=.05;
    
    vec3 color=baseColor*(ambient+.8*diff);
    
    gl_FragColor=vec4(color,1.);
}